import { STATUS } from "@/utils/constants";

import {
  RESET,
  SET_IS_FETCHING_TEMPLATE_STATUS,
  SET_IS_SAVING_TEMPLATE_STATUS,
  SET_TEMPLATE,
} from "./editor.actionTypes";

const initialState = {
  isFetchingTemplateStatus: STATUS.IDLE,
  isSavingTemplateStatus: STATUS.IDLE,
  template: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING_TEMPLATE_STATUS: {
      return {
        ...state,
        isFetchingTemplateStatus: action.payload,
      };
    }

    case SET_IS_SAVING_TEMPLATE_STATUS: {
      return {
        ...state,
        isSavingTemplateStatus: action.payload,
      };
    }

    case SET_TEMPLATE: {
      return {
        ...state,
        template: action.payload,
      };
    }

    case RESET: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
